import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityLarkAppApi } from 'api';

export const filterEntityLarkApp = createAsyncThunk(
  'entityLarkApp/filterEntityLarkApp',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.filter(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityLarkApp = createAsyncThunk(
  'entityLarkApp/createEntityLarkApp',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityLarkApp = createAsyncThunk(
  'entityLarkApp/findOneEntityLarkApp',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityLarkApp = createAsyncThunk(
  'entityLarkApp/updateEntityLarkApp',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityLarkAppApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityLarkApp = createAsyncThunk(
  'entityLarkApp/deleteEntityLarkApp',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkConnectEntityLarkApp = createAsyncThunk(
  'entityLarkApp/checkConnectEntityLarkApp',
  async (param: { appID: string; appSecret: string }, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.checkConnect(param);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkCanDeleteEntityLarkApp = createAsyncThunk(
  'entityLarkApp/checkCanDeleteEntityLarkApp',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkAppApi.checkCanDelete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface EntityLarkAppState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
}

const initialState: EntityLarkAppState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
};

const entityLarkAppSlice = createSlice({
  name: 'entityLarkApp',
  initialState,
  reducers: {
    reloadEntityLarkApp(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityLarkApp(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityLarkApp(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entityLarkAppReducer } = entityLarkAppSlice;

export const {
  reloadEntityLarkApp,
  updateSavedPaginationEntityLarkApp,
  updateSavedListEntityLarkApp,
} = actions;

export default entityLarkAppReducer;
